const e = "af.save-to-library-menu-loaded", s = class s extends CustomEvent {
  constructor(a) {
    super(e, { detail: a, bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = e;
let t = s;
export {
  e as EVENT_NAME,
  t as default
};
//# sourceMappingURL=SaveToLibraryMenuLoadedEvent.js.map
